import { Box, Divider, Typography, Avatar } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useState, useCallback, useEffect } from "react";
import { getInvoiceData } from "../../features/invoice/invoiceSlice";
import { getPolicy } from "../../features/policy/policySlice";
import { getPharmacyImage } from "../../utils/utils";
import InvoiceTable from "./invoiceTable";
import AppButton from "../common/AppButton";

const headerData = ["Item(s)", "QTY", "Price", "Amt"];

export const InvoiceModal = ({
  invoiceId,
  selectedInstructions,
  onClose,
  onSaveAndClose,
  isPrint,
  handleCloseEditFunction,
}: any) => {
  const dispatch = useAppDispatch();
  const profiledata: any = useAppSelector(
    (state: any) => state.profile.profileDetails
  );
  const pharmacyID = Number(localStorage?.getItem("pharmacyId"));
  const [tableRowData, setTableRowData] = useState<any[]>([]); // Initialize as an empty array
  const [rowData, setRowData] = useState<any>();
  const pharmacyId = localStorage?.getItem("pharmacyId") || "";

  const imageTimestamp = Date.now();

  if (invoiceId) {
  }
  const GetPolicy = useCallback(() => {
    dispatch(getPolicy(pharmacyID));
  }, [dispatch, pharmacyID]);
  useEffect(() => {
    if (pharmacyID) GetPolicy();
  }, [pharmacyID, GetPolicy]);
  const { policyPayload }: any = useAppSelector((state) => state.policy);

  const getInvoice = useCallback(async () => {
    if (invoiceId) {
      const obj = {
        pharmacy_id: pharmacyId,
        invoice_id: invoiceId,
      };
      try {
        const res: any = await dispatch(getInvoiceData(obj));

        if (res?.payload) {
          setRowData(res?.payload);
        }
      } catch (error) {
        console.error("Error fetching invoice data:", error);
      }
    }
  }, [dispatch, invoiceId, pharmacyId]);

  useEffect(() => {
    getInvoice();
  }, [getInvoice]);

  // useEffect(() => {
  //   if (rowData?.sales?.length > 0) {
  //     const newData = rowData?.sales?.map((item: any) => ({
  //       "Item(s)": (
  //         <>
  //           {item?.medicine_name}
  //           <span style={{ fontSize: "16px", marginLeft: "3px" }}>
  //             {item?.batch?.pharmacy_medicine?.dose}
  //           </span>
  //         </>
  //       ),
  //       QTY: item?.quantity_sold,
  //       Price: item?.sell_price,
  //       Amt: item?.amount_to_be_paid,
  //       Discount: item?.discount_amount,
  //       "Payable Amt": item?.amount_after_discount,
  //     }));

  //     setTableRowData(newData);
  //   } else {
  //     setTableRowData([]); // Initialize as an empty array
  //   }
  // }, [rowData]);

  useEffect(() => {
    if (rowData?.sales?.length > 0) {
      const groupedData = rowData.sales.reduce((acc: any[], item: any) => {
        const key = item?.batch?.pharmacy_medicine?.id;
        const existingItem = acc.find((entry) => entry.id === key);

        if (existingItem) {
          // Update the existing entry by summing up values
          existingItem.QTY += item?.quantity_sold;
          existingItem.Amt += item?.amount_to_be_paid;
          existingItem.Discount += item?.discount_amount;
          existingItem["Payable Amt"] += item?.amount_after_discount;
        } else {
          // Add new entry
          acc.push({
            id: key,
            "Item(s)": (
              <>
                {item?.medicine_name}
                <span style={{ fontSize: "16px", marginLeft: "3px" }}>
                  {((d?: string) => {
                    const cleaned = (d ?? "").replace(/\bnull\b/gi, "").trim();
                    return cleaned || "";
                  })(item?.batch?.pharmacy_medicine?.dose)}
                </span>
              </>
            ),
            QTY: item?.quantity_sold,
            Price: item?.sell_price,
            Amt: item?.amount_to_be_paid,
            Discount: item?.discount_amount,
            "Payable Amt": item?.amount_after_discount,
          });
        }
        return acc;
      }, []);

      setTableRowData(groupedData);
    } else {
      setTableRowData([]); // Initialize as an empty array
    }
  }, [rowData]);

  // Convert ISO date string to a formatted date

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const date = rowData?.invoice_date && formatDate(rowData?.invoice_date);
  const time =
    rowData?.created_at &&
    new Date(rowData?.created_at).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });

  const pharmacyName = rowData?.pharmacy?.name;
  const pharmacyAddress = rowData?.pharmacy?.address?.address;
  const licenseNo = rowData?.pharmacy?.pharmacy_auth?.license_number;
  const phone = rowData?.pharmacy?.phone_number;
  const userName = rowData?.add_by_admin ? "Admin" : rowData?.created_by?.name;
  const ID = rowData?.id || ""; // Extracting invoice ID from rowData
  const discount = rowData?.discount_Amount;
  const discountPercentage = rowData?.discount_percentage;
  const netAmount = rowData?.after_discount_amount;
  const paymentType = rowData?.payment_type;

  const paymentReceived = rowData?.paid_amount;
  const balanceReturned = rowData?.return_amount;

  // Create a set to store unique purchased items
  const purchasedItems = new Set();

  // Iterate over tableRowData to add each unique purchased item to the set
  tableRowData?.forEach((item: any) => {
    purchasedItems?.add(item["Purchased Item"]);
  });

  // Calculate the total number of unique purchased items
  const totalItems = purchasedItems?.size;

  const totalQuantity = tableRowData?.reduce(
    (acc: any, curr: any) => acc + curr.QTY,
    0
  );
  const totalAmount = tableRowData?.reduce(
    (acc: any, curr: any) => acc + curr.Amt,
    0
  );
  const totalDiscount = tableRowData?.reduce(
    (acc: any, curr: any) => acc + curr.Discount,
    0
  );
  const totalDiscountedAmount = tableRowData?.reduce(
    (acc: any, curr: any) => acc + curr["Payable Amt"],
    0
  );

  const hasDiscountPercentagePrevious = tableRowData?.some(
    (entry: any) => entry?.Discount
  );

  const handleSaveInvoice = () => {
    onClose(); // Close the modal
    onSaveAndClose();
    if (typeof handleCloseEditFunction === 'function') {
      handleCloseEditFunction(); // Only call if function exists
    }
    localStorage?.removeItem("salesData");
  };

  const handleSaveAndPrintInvoice = () => {
    onClose(); // Close the modal
    onSaveAndClose();
    if (typeof handleCloseEditFunction === 'function') {
      handleCloseEditFunction(); // Only call if function exists
    }
    localStorage?.removeItem("salesData");
    window?.print(); // Trigger print dialog
  };

  const handlePrintOnly = () => {
    onClose(); // Close the modal
    onSaveAndClose();
    window?.print();
  };
  const paymentTypeLabels: any = {
    0: "Jazz Cash",
    1: "Easy Paisa",
    2: "Bank Card",
    3: "Cash",
    4: "Other",
    5: "Bank Transfer",
  };
  return (
    <>
      <style>
        {`
      @media print {
        @page {
          margin: 0; /* Removes the default margin that may add header and footer */
        }
        body {
          margin: 1cm; /* Adjust the margin as needed */
        }
        header, footer {
          display: none; /* Hides any header or footer content */
        }
      }
    `}
      </style>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          textAlign: "center",
        }}
      >
        <Box sx={{ display: " flex", margin: "auto", alignItems: "center" }}>
          <Avatar
            sx={{ bgcolor: "white", height: "60px", width: "60px" }}
            src={`${getPharmacyImage(pharmacyId)}&t=${imageTimestamp}`}
          ></Avatar>
        </Box>
        <Box
          sx={{
            fontWeight: 600,
            fontSize: "35px",
            padding: "7px",
            lineHeight: "38px",
            //wordWrap: "break-word", // Ensure text wraps within the box
          }}
        >
          {pharmacyName}
        </Box>
        <Box
          sx={{
            textAlign: "center",
            fontWeight: 400,
            fontSize: "27px",
            lineHeight: "32px",
            padding: "7px",
            // wordWrap: "break-word", // Ensure text wraps within the box
          }}
        >
          {pharmacyAddress}
        </Box>
        <Box
          sx={{
            // bgcolor: "black",
            color: "black",
            textAlign: "center",
            fontWeight: 500,
            paddingY: "9px",
            fontSize: "27px",
            lineHeight: "18px",
            wordWrap: "break-word", // Ensure text wraps within the box
          }}
        >
          Phone # {profiledata?.user?.contact_number}
        </Box>
        <Box
          sx={{
            textAlign: "center",
            fontWeight: 400,
            fontSize: "27px",
            lineHeight: "32px",
            padding: "7px",
            // wordWrap: "break-word", // Ensure text wraps within the box
          }}
        >
          License No. {licenseNo}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            textAlign: "center",
            fontWeight: 400,
            fontSize: "23px",
            lineHeight: "25px",
            mt: "5px",
            wordWrap: "break-word", // Ensure text wraps within the box
          }}
        >
          <Box>Inv. No: {ID}</Box>
          <Box>C. By: {userName}</Box>
          <Box>
            {date} {time}{" "}
          </Box>
        </Box>
      </Box>

      <Box sx={{ mt: 3, width: "100%" }}>
        <InvoiceTable
          headerData={headerData}
          rowData={tableRowData}
          totalItems={totalItems}
          totalQuantity={totalQuantity}
          totalAmount={totalAmount}
          totalDiscount={totalDiscount}
          totalDiscountedAmount={totalDiscountedAmount}
          discountPercentage={discountPercentage}
          discount={discount}
          hasDiscountPercentagePrevious={hasDiscountPercentagePrevious}
          isPrint={isPrint}
        />
      </Box>

      <Divider />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          fontWeight: 500,
          fontSize: "27px",
          lineHeight: "25px",
          mt: 3,
          marginRight: 3, // Add margin to the right
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>Gross Total:</Box>
          <Box marginLeft={1}>
            Rs.{" "}
            {Math.round(totalAmount).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Box>
        </Box>
        {discount !== 0 && discount !== null && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>Discount:</Box>
            {hasDiscountPercentagePrevious ? (
              <Box marginLeft={1}>
                Rs.{" "}
                {Math.round(discount)?.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            ) : (
              <Box marginLeft={1}>
                {" "}
                Rs.{" "}
                {Math.round(discount)?.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
                ({discountPercentage}%)
              </Box>
            )}
          </Box>
        )}
        {(hasDiscountPercentagePrevious ||
          (discountPercentage > 0 && netAmount > 0)) && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>Net Total:</Box>
            <Box marginLeft={1}>
              Rs.{" "}
              {Math.round(netAmount)?.toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Box>
          </Box>
        )}
        {/* {(paymentReceived !== 0 && paymentReceived !== null) && <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>Payment Received: </Box>
          <Box marginLeft={1}>Rs. {Math.round(paymentReceived)?.toFixed(2)}</Box>
        </Box>
        }
        {(balanceReturned !== 0 && balanceReturned !== null) && <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>Balance Returned:</Box>
          <Box marginLeft={1}>Rs. {balanceReturned?.toFixed(2)}</Box>
        </Box>
        } */}
      </Box>
      {policyPayload?.policy !== undefined && <Divider sx={{ mt: 2 }} />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Box sx={{ mt: "10px" }}>
          {policyPayload?.policy !== undefined && (
            <Typography
              sx={{
                textAlign: "left",
                fontWeight: 400,
                width: "100%",
                lineHeight: "32px",
                fontSize: "22px",
                padding: "7px",
                //textTransform: "uppercase",
                mb: 1,
              }}
            >
              {/* <span style={{ fontWeight: 600 }}>
                Policy: </span>{" "} */}
              {policyPayload?.policy?.policy}
            </Typography>
          )}
          {selectedInstructions?.map((instruction: any, index: any) => (
            <Typography
              sx={{
                textAlign: "left",
                fontWeight: 400,
                fontSize: "22px",
                width: "100%",
                lineHeight: "32px",
                padding: "7px",
                paddingBottom: "0px",
                // textTransform: "uppercase"
              }}
            >
              <span style={{ fontWeight: 600 }}>Instruction: </span>
              {instruction.description}
            </Typography>
          ))}
        </Box>
        <Divider sx={{ mt: 0 }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            textAlign: "center",
            fontWeight: 400,
            fontSize: "22px",
            lineHeight: "24px",
            wordBreak: "break-word",
            p: 2,
          }}
        >
          Software By E-Mareez Care, Phone# 03095558054
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            "@media print": {
              display: "none", // Hide this section when printing
            },
          }}
        >
          {!isPrint ? (
            <>
              <AppButton
                variant="contained"
                color="primary"
                title="Save Invoice"
                sx={{ width: "48%" }}
                onClick={handleSaveInvoice}
              />
              <AppButton
                variant="contained"
                color="primary"
                title="Save & Print Invoice"
                sx={{ width: "48%", backgroundColor: " #01A768" }}
                onClick={handleSaveAndPrintInvoice}
              />
            </>
          ) : (
            <AppButton
              variant="contained"
              color="primary"
              title="Print Invoice"
              sx={{ width: "100%" }}
              onClick={handlePrintOnly}
            />
          )}
        </Box>
      </Box>
    </>
  );
};
